import * as types from '../mutation-types'

import { ORDER_HISTORY, DRAFT_ORDER_HISTORY, INVOICE_HISTORY } from '~/mockup/history.data'
import { buildFilterTabData, flatten } from '~/helpers/data-structure'
import historyService from '../services/history'

// state
export const state = {
  ordersHistory: [],
  draftOrdersHistory: [],
  invoicesHistory: [],
  filterTabsOrderHistory: []
}

// getters
export const getters = {
  ordersHistory: state => state.ordersHistory,
  draftOrdersHistory: state => state.draftOrdersHistory,
  invoicesHistory: state => state.invoicesHistory,
  getSelectedChildrenFilterTabItems: state => {
    return state.filterTabsOrderHistory
      ? flatten(state.filterTabsOrderHistory)
        .filter(item => !!item.checked)
      : []
  }
}

// mutations
export const mutations = {
  [types.FETCH_ORDER_HISTORY_SUCCESS] (state, { ordersHistory }) {
    state.ordersHistory = ordersHistory
  },
  [types.FETCH_DRAFT_ORDER_HISTORY_SUCCESS] (state, { draftOrdersHistory }) {
    state.draftOrdersHistory = draftOrdersHistory
  },
  [types.FETCH_INVOICE_HISTORY_SUCCESS] (state, { invoicesHistory }) {
    state.invoicesHistory = invoicesHistory
  },
  [types.FETCH_FILTER_TAB_ORDER_HISTORY_SUCCESS] (state, { filterTabsOrderHistory }) {
    state.filterTabsOrderHistory = buildFilterTabData(filterTabsOrderHistory)
  },
  [types.SET_HISTORY_FILTER_TAB] (state, { filterTabsOrderHistory }) {
    state.filterTabsOrderHistory = filterTabsOrderHistory
  }
}

// actions
export const actions = {
  fetchOrderHistory ({ commit }) {
    commit(types.FETCH_ORDER_HISTORY_SUCCESS, {
      ordersHistory: ORDER_HISTORY
    })
  },
  fetchDraftOrderHistory ({ commit }) {
    commit(types.FETCH_DRAFT_ORDER_HISTORY_SUCCESS, {
      draftOrdersHistory: DRAFT_ORDER_HISTORY
    })
  },
  fetchInvoiceHistory ({ commit }) {
    commit(types.FETCH_INVOICE_HISTORY_SUCCESS, {
      invoicesHistory: INVOICE_HISTORY
    })
  },
  async fetchFilterTabsOrderHistory ({ commit }) {
    const { data } = await historyService.fetchFilterTabsOrderHistory()

    commit(types.FETCH_FILTER_TAB_ORDER_HISTORY_SUCCESS, {
      filterTabsOrderHistory: data
    })
  },
  setHistoryFilterTab({ commit }, data) {
    commit(types.SET_HISTORY_FILTER_TAB, data)
  }
}
